var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrownSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 14H12.6667M7.708 2.17733C7.73678 2.12507 7.77905 2.08149 7.83041 2.05114C7.88177 2.02078 7.94034 2.00477 8 2.00477C8.05966 2.00477 8.11823 2.02078 8.16959 2.05114C8.22095 2.08149 8.26323 2.12507 8.292 2.17733L10.26 5.91333C10.3069 5.99984 10.3724 6.07489 10.4518 6.13308C10.5312 6.19127 10.6224 6.23117 10.7191 6.24991C10.8157 6.26864 10.9153 6.26576 11.0106 6.24145C11.106 6.21715 11.1948 6.17203 11.2707 6.10933L14.122 3.66667C14.1767 3.62215 14.2442 3.59614 14.3146 3.5924C14.3851 3.58866 14.4549 3.60736 14.5141 3.64583C14.5732 3.6843 14.6186 3.74054 14.6438 3.80646C14.6689 3.87238 14.6725 3.94458 14.654 4.01267L12.7647 10.8433C12.7261 10.9831 12.643 11.1065 12.528 11.1948C12.413 11.2831 12.2723 11.3315 12.1273 11.3327H3.87333C3.72822 11.3317 3.58741 11.2833 3.47226 11.195C3.35712 11.1067 3.27393 10.9832 3.23533 10.8433L1.34667 4.01333C1.32817 3.94525 1.33175 3.87305 1.35689 3.80713C1.38204 3.74121 1.42745 3.68496 1.4866 3.6465C1.54575 3.60803 1.61557 3.58932 1.68603 3.59307C1.75648 3.59681 1.82393 3.62281 1.87867 3.66733L4.72933 6.11C4.8052 6.17269 4.89401 6.21781 4.98938 6.24212C5.08475 6.26642 5.18431 6.26931 5.28093 6.25057C5.37755 6.23184 5.46882 6.19194 5.54819 6.13375C5.62757 6.07555 5.69307 6.00051 5.74 5.914L7.708 2.17733Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownSmall);
export default __webpack_public_path__ + "static/media/crown-small.2f17461a7de1e4d32054f03cfcbd0680.svg";
export { ForwardRef as ReactComponent };